module.exports = __webpack_public_path__ + "img/no-audio.9918e313.svg";